import { PatientTriageRequestItem } from "@accurx/concierge/types";

export const getSearchDetails = (
    item: PatientTriageRequestItem | undefined,
    searchMode: "dateOfBirth" | "patientName",
) => {
    if (!item) return undefined;
    const responses = item.sections.flatMap((section) => section.responses);

    if (searchMode === "dateOfBirth") {
        /**
         * EMIS uses date of birth
         */
        const question = responses.find(({ question }) => question === "DOB");
        const dateOfBirth = question?.answer;
        return { searchTerm: dateOfBirth };
    } else {
        /**
         * SystmOne and Vision first name and last name
         */
        const question = responses.find(({ question }) => question === "Name");
        const name = question?.answer;
        if (!name) return undefined;
        const [lastName, firstName] = name.split(", ");
        return { firstName, lastName };
    }
};
